<ngx-invisible-recaptcha #captchaElem
                         [siteKey]="siteKey"
                         (reset)="handleReset()"
                         (ready)="handleReady()"
                         (load)="handleLoad()"
                         (expire)="handleError()"
                         (error)="handleError()"
                         (success)="handleSuccess($event)"
                         [useGlobalDomain]="false"
                         [type]="type"
                         [theme]="theme"
                         [badge]="badge"
                         [ngModel]="recaptcha"
                         [ngModelOptions]="{ standalone: true }">
</ngx-invisible-recaptcha>
